module.exports = __webpack_public_path__ + "img/des_muyu_3.285fcb11.jpg";